<template>
  <div id="app">
    <header class="navbar navbar-expand navbar-dark flex-column flex-md-row bd-navbar">
    <!-- {{ this.$store.state.auth.competitions }} -->
    <nav class="navbar navbar-expand navbar-dark bg-dark">
      <div class="navbar-brand">
        <a href="/" class="navbar-brand">Andro Opprop <small>(beta)</small></a>
        <!-- <div class="small">
          {{ 
            this.$store.state.auth.selectedCompetition 
              ? (this.$store.state.auth.competitions.find(comp => comp.id === this.$store.state.auth.selectedCompetition).name || 'NaN') 
              : '&nbsp;' 
          }}
        </div> -->
      </div>
      <div v-if="currentUser" class="navbar-nav ml-auto">
        <SelectCompetition></SelectCompetition>
      </div>

      <div class="navbar-nav-scroll">
        <ul class="navbar-nav bd-navbar-nav flex-row">
          <!-- <div v-if="this.$store.state.auth.selectedCompetition">
            <li class="nav-item">
              <div class="nav-link navbar-brand">TEST</div>
            </li>
          </div> -->
          <!-- <li class="nav-item">
            <router-link to="/" class="nav-link">
              <font-awesome-icon icon="home" />Hjem
            </router-link>
          </li> -->
          <!-- <li v-if="checkRole([{name:'frisys_admin'},{name:'competition_admin', verify_competition:true}])" class="nav-item">
            <router-link to="/admin" class="nav-link">TEST</router-link>
          </li> -->
          <li v-if="checkRole([{name:'frisys_admin'},{name:'frisys_tester_admin'}])" class="nav-item">
            <router-link to="/admin" class="nav-link">
              <!-- <font-awesome-icon icon="user-plus" />-->
              Admin
            </router-link>
          </li>
          <li v-if="checkRole(['frisys_admin',{name:'competition_admin'}])" class="nav-item">
            <router-link to="/competitions" class="nav-link">Stevner</router-link>
          </li>
          <li v-if="selectedCompetition" class="nav-item">
            <!-- <router-link to="/competition/" class="nav-link">Stevne</router-link> -->
            <router-link 
              :to="{ name:'competition', params:{competition_id: selectedCompetition.id} }" 
              class="nav-link">
              <font-awesome-icon icon="home" />Stevneinfo</router-link>
          </li>
          <!-- <li v-if="checkRole([{name:'frisys_admin'},{name:'competition_admin', verify_competition:true}])" class="nav-item"> -->
          <!-- <li v-if="checkRole([{name:'frisys_admin'},{name:'competition_admin'}])" class="nav-item">
            <router-link :to="'/competition/'+selectedCompetition.id+'/admin'" class="nav-link">Arrangør</router-link>
          </li> -->
          <li v-if="currentUser && selectedCompetitionId" class="nav-item">
            <router-link :to="'/competition/'+selectedCompetitionId+'/events'" class="nav-link">
              <font-awesome-icon icon="person-booth" /> Øvelser</router-link>
          </li>
          <li v-if="currentUser && selectedCompetitionId" class="nav-item">
            <router-link 
                :to="{ path:'/competition/'+selectedCompetitionId+'/teams'}"
              class="nav-link">
              <font-awesome-icon icon="people-arrows" /> Lagleder</router-link>
          </li>
          <!-- <li v-if="showModeratorBoard" class="nav-item">
            <router-link to="/event" class="nav-link">Øvelse</router-link>
          </li> -->
          <li v-if="showUserBoard" class="nav-item">
            <router-link v-if="currentUser" to="/user" class="nav-link">User</router-link>
          </li>
          <div v-if="selectedCompetition && checkRole([{name:'frisys_admin'},{name:'competition_admin', verify_competition:true}])">
            <li class="nav-item">
              <router-link 
                :to="{ path:'/mod/competition/'+selectedCompetition.id+'/participants'}"
              class="nav-link">Deltakere</router-link>
            </li>
          </div>
          <div>
            <li v-if="currentUserIsParticipant" class="nav-item">
              <router-link 
                v-if="selectedCompetition && selectedParticipantId"
                :to="{ path:'/competition/'+selectedCompetition.id+'/participant/'+selectedParticipantId}" 
              class="nav-link">Deltaker</router-link>
              <router-link 
                v-if="selectedCompetition && !selectedParticipantId"
                :to="{ path:'/competition/'+selectedCompetition.id+'/participant/0'}"
              class="nav-link">Deltaker</router-link>
            </li>
          </div>
          <li v-if="currentUser && currentUser.vippsuser" class="nav-item">
            <router-link to="/competition/add" class="nav-link">
              <font-awesome-icon icon="calendar-plus" /> Opprett stevne</router-link>
          </li>
          </ul>
      </div>

      <div v-if="!currentUser" class="navbar-nav ml-auto">
        <li class="nav-item">
          <router-link to="/login" class="nav-link">
            <font-awesome-icon icon="sign-in-alt" />Logg inn
          </router-link>
        </li>
      </div>

      <div v-if="currentUser" class="navbar-nav ml-auto">
        <li v-if="checkRole('frisys_admin')" class="nav-item">
          <router-link to="/register" class="nav-link">
            <font-awesome-icon icon="user-plus" />Registrer ny bruker
          </router-link>
        </li>
        <li v-if="selectedCompetition && checkRole(['frisys_admin',{name:'competition_admin', verify_competition:true}])" class="nav-item">
          <router-link 
            :to="{ path:'/competition/'+selectedCompetition.id+'/admin'}" class="nav-link">
            StevneAdmin
          </router-link>
        </li>
        <li v-if="currentUser && currentUser.vippsuser && currentUser.vippsuser.phone_number " class="nav-item">
          <router-link to="/vippsloggedin" class="nav-link">
            <font-awesome-icon icon="user" />
            {{ currentUser.vippsuser.name }} ({{ currentUser.vippsuser.phone_number }})
          </router-link>
        </li>
        <li v-else-if="showUserBoard" class="nav-item">
          <router-link to="/profile" class="nav-link">
            <font-awesome-icon icon="user" />
            {{ currentUser.username }}
          </router-link>
        </li>
        <li class="nav-item">
          <a class="nav-link" href @click.prevent="logOut">
            <font-awesome-icon icon="sign-out-alt" />Logg ut
          </a>
        </li>
      </div>
    </nav>
    </header>

    <div class="container">
      <router-view />
    </div>
  </div>
</template>

<script>
import SelectCompetition from './components/SelectCompetition.vue';
export default {
  data() {
    return {
      debug: false
    };
  },
  components: {
    SelectCompetition
  },
  computed: {
    showUserBoard() {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.includes('ROLE_USER');
      }

      return false;
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/');
    },
  }
};
</script>

